import { render, staticRenderFns } from "./CancelPlatformSubscriptionModal.vue?vue&type=template&id=0897acaf&scoped=true"
import script from "./CancelPlatformSubscriptionModal.vue?vue&type=script&lang=js"
export * from "./CancelPlatformSubscriptionModal.vue?vue&type=script&lang=js"
import style0 from "./CancelPlatformSubscriptionModal.vue?vue&type=style&index=0&id=0897acaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897acaf",
  null
  
)

export default component.exports